import React from 'react';
import AuditConnexions from '../../gestion-audit/AuditConnexions';

export default function AuditConnectionsMobile() { return <AuditConnexions mobile />; }
